
import {Component, Mixins, Prop} from "vue-property-decorator";
import ObjectInputMixin from "@/mixins/ObjectInputMixin.vue";
import TcKimlikNumarasi from "@/components/inputs/TcKimlikNumarasi.vue";
import FormWrapper from "@/components/FormWrapper.vue";

@Component({
  components: { TcKimlikNumarasi, FormWrapper },
})
export default class MalikiBilgisiForm extends Mixins(ObjectInputMixin) {
  protected onValueChange() {
    if (!('tc_no' in this.localValue)) {
      this.$set(this.localValue, 'tc_no', null);
    }
  }

  input(value: any = null, isChangeData: boolean = false) {
    if (value && isChangeData) this.localValue = value;
    if (!this.localValue.tc_no) {
      this.$set(this.localValue, 'tc_no', null);
    }
    this.$emit('input', this.localValue);
    this.$emit('value', this.localValue);
    this.$forceUpdate();
  }
}
